export default __webpack_public_path__ + "static/media/avatar_155.84c56c2a.png";